export const transactionParty = {
  TransactionParty: {
    keyFields: ["id", "roles"],
  },
}
